import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CertificateService {
  constructor(protected client: HttpClient) {}

  setCertKey(key: string) {
    // Todo: see if this is an issue for the form data input.
    return this.client.post("/api/certificate", { key });
  }

  getCertificateDisplayInfo() {
    return this.client.get<CertificateDisplayInfo>(`/api/certificate/info`);
  }

  issueCertRequest(request: CertificateRequest) {
    return this.client.post<CertificateRequestData>(
      "/api/certificate-issue",
      request
    );
  }

  getCertPass() {
    return this.client.post<{ key: string }>("/api/certificate/pass", {});
  }
}

export interface CertificateDisplayInfo {
  subject: string;
  used: boolean;
}

export interface CertificateRequest {
  certificateRecipientSsn: string;
  phoneNumber: string;
  vehicleCallsign: string;
  stationId: number | null;
  districtId: number | null;
  serviceTypeId: number;
  accessGroupId: number;
}

export interface CertificateRequestData {
  certificateRequestKey: string;
}
